'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBox = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defineMessages;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _LocalizableMessage = require('components/LocalizableMessage/LocalizableMessage');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _icons = require('constants/icons');

var _SearchBox = require('./SearchBox.constants');

var _LocationFieldContainer = require('./LocationFieldContainer');

var _KeywordFieldContainer = require('./KeywordFieldContainer');

var _Search = require('../Search.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)((_defineMessages = {}, (0, _defineProperty3.default)(_defineMessages, _Search.VERTICALS.all, {
  id: 'search.search-box.message.all',
  defaultMessage: 'All'
}), (0, _defineProperty3.default)(_defineMessages, _Search.VERTICALS.gym, {
  id: 'search.search-box.message.gym',
  defaultMessage: 'All gyms'
}), (0, _defineProperty3.default)(_defineMessages, _Search.VERTICALS.fitness, {
  id: 'search.search-box.message.fitness',
  defaultMessage: 'All fitness'
}), (0, _defineProperty3.default)(_defineMessages, _Search.VERTICALS.wellness, {
  id: 'search.search-box.message.wellness',
  defaultMessage: 'All wellness'
}), _defineMessages));

var SearchBox = exports.SearchBox = function SearchBox(_ref) {
  var intl = _ref.intl,
      openPanel = _ref.openPanel,
      onPanelClose = _ref.onPanelClose,
      mediaQueryLg = _ref.mediaQueryLg,
      onToggleMapView = _ref.onToggleMapView,
      isMapView = _ref.isMapView,
      onClickCollapsedSearchBar = _ref.onClickCollapsedSearchBar,
      keywordText = _ref.keywordText,
      locationText = _ref.locationText,
      selectedVertical = _ref.selectedVertical,
      isHidden = _ref.isHidden;

  var isPanelOpen = !!openPanel;
  var panelOpenOnMobile = isPanelOpen && !mediaQueryLg;
  var searchPanelCollapsed = !panelOpenOnMobile && !mediaQueryLg;
  var locationOpen = openPanel === _SearchBox.PANEL_NAMES.location;
  var keywordOpen = openPanel === _SearchBox.PANEL_NAMES.keyword;
  var locationOpenOnMobile = panelOpenOnMobile && locationOpen;
  var keywordOpenOnMobile = panelOpenOnMobile && keywordOpen;
  var mapIcon = require('../../../../static/img/icon/mapview.svg');
  var listIcon = require('../../../../static/img/icon/listview.svg');
  var defaultKeywordText = selectedVertical && intl.formatMessage(messages[selectedVertical]);

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('searchbox', {
        'searchbox--panel-open': !!panelOpenOnMobile,
        hidden: isHidden
      })
    },
    searchPanelCollapsed ? _react2.default.createElement(
      'div',
      { className: 'searchbox__collapsed' },
      _react2.default.createElement(
        'div',
        {
          className: 'searchbox__collapsed__field-info',
          onClick: onClickCollapsedSearchBar
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: _icons.DESIGN_SYSTEM.lookingGlass }),
        _react2.default.createElement(
          'b',
          null,
          keywordText || defaultKeywordText || ''
        ),
        _react2.default.createElement(
          'span',
          { className: 'color-text-light' },
          _react2.default.createElement(_LocalizableMessage.LocalizableMessage, { message: locationText })
        )
      ),
      _react2.default.createElement(
        'div',
        {
          className: 'searchbox__collapsed__view-toggler',
          onClick: onToggleMapView
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: isMapView ? listIcon : mapIcon })
      )
    ) : _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('searchbox__controls', {
          'searchbox__controls--open': isPanelOpen
        })
      },
      panelOpenOnMobile && _react2.default.createElement(
        'div',
        {
          className: 'searchbox__controls__close',
          onClick: onPanelClose
        },
        _react2.default.createElement(_reactInlinesvg2.default, { src: require('../../../../static/img/icon/back.svg') })
      ),
      _react2.default.createElement(
        'div',
        { className: 'searchbox__controls__fields' },
        _react2.default.createElement(_KeywordFieldContainer.KeywordFieldContainer, {
          isOpen: keywordOpen,
          isOpenPanelOnMobile: keywordOpenOnMobile
        }),
        _react2.default.createElement(_LocationFieldContainer.LocationFieldContainer, {
          isOpen: locationOpen,
          isOpenPanelOnMobile: locationOpenOnMobile
        })
      )
    )
  );
};

SearchBox.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  openPanel: _propTypes2.default.string,
  onPanelClose: _propTypes2.default.func.isRequired,
  onToggleMapView: _propTypes2.default.func.isRequired,
  mediaQueryLg: _propTypes2.default.bool,
  isMapView: _propTypes2.default.bool,
  onClickCollapsedSearchBar: _propTypes2.default.func.isRequired,
  keywordText: _propTypes2.default.string.isRequired,
  locationText: _propTypes2.default.string.isRequired,
  isHidden: _propTypes2.default.bool,
  selectedVertical: _propTypes2.default.string
};